import { commonRoutes } from '@didaskill/ui/domain';

export default {
  // Routes below are for the unauthenticated user
  ...commonRoutes,

  AI_INTERACTIONS: {
    ROOT: '/ai-interactions',
  },

  ASSIGNMENTS: {
    ROOT: '/assignments',
    ASSIGNMENT: '/assignments/:assignmentId',
  },

  ASSIGNMENT_SUBMISSIONS: {
    ROOT: '/assignment-submissions',
  },

  AUDIT_LOGS: {
    ROOT: '/audit-logs',
  },

  COURSES: {
    ROOT: '/courses',
    COURSE: '/courses/:courseId',

    TEACHING_UNITS: {
      TEACHING_UNIT: '/courses/:courseId/teaching-units/:teachingUnitId/settings',

      LESSON: '/courses/:courseId/teaching-units/:teachingUnitId/lessons/:lessonId',
    },
  },

  HELP_ARTICLES: {
    ROOT: '/help-articles',
    HELP_ARTICLE: '/help-articles/:helpArticleId',
  },

  HOME: commonRoutes.APP,

  LEARNING_RESOURCES: {
    ROOT: '/learning-resources',
    LEARNING_RESOURCE: '/learning-resources/:learningResourceId',
  },

  LEGAL_DOCUMENTS: {
    ROOT: '/legal-documents',
  },

  LESSONS: {
    ROOT: '/lessons',
    LESSON: '/lessons/:lessonId/',
    LESSON_STATISTICS: '/lessons/:lessonId/statistics',
    LESSON_VERSION: '/lessons/:lessonId/versions/:versionNumber/',
    LESSON_VERSION_SEQUENCE:
      '/lessons/:lessonId/versions/:versionNumber/sequences/:sequenceVersionId',
  },

  NEWS: {
    CREATE: '/news/create',
    EDIT: '/news/edit/:newsId',
    LIST: '/news/list',
  },

  STATISTICS: {
    ROOT: '/statistics',
  },

  SKILLS: {
    ROOT: '/skills',
  },

  SKILL_TAGS: {
    ROOT: '/skill-tags',
  },

  USERS_INTERNAL: {
    ROOT: '/users-internal',
  },

  USERS_STUDENTS: {
    LIST: '/users-students/list',
    EXTRACT: '/users-students/extract',
  },

  VIRTUAL_CLASSROOMS: {
    ROOT: '/virtual-classrooms',
    VIRTUAL_CLASSROOM: '/virtual-classrooms/:virtualClassroomId',
  },
} as const;
